// import axios from 'axios';
// import { clearAuth, getAuthToken } from './auth';

// const isLocalHost = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);
// const API_URL = process.env.REACT_APP_API_URL || (isLocalHost ? 'http://localhost:5000/api' : '/api');

// const api = axios.create({
//   baseURL: API_URL,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// api.interceptors.request.use((config) => {
//   const token = getAuthToken();
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error?.response?.status === 401) {
//       clearAuth();
//       if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
//         window.location.assign('/login');
//       }
//     }
//     return Promise.reject(error);
//   }
// );

// // Authentication endpoints
// export const login = (data) => api.post('/auth/login', data);
// export const forgotPassword = (data) => api.post('/auth/forgot-password', data);
// export const resetPassword = (data) => api.post('/auth/reset-password', data);
// export const getMe = () => api.get('/auth/me');
// export const logout = () => api.post('/auth/logout');

// // Simulation endpoints
// export const startSimulation = (data) => api.post('/simulation/start', data);
// export const stopSimulation = (profileId = 'love_delhi') => api.post('/simulation/stop', { profileId });
// export const getSimulationStatus = (profileId = 'love_delhi') => api.get('/simulation/status', { params: { profileId } });
// export const getSimulationProfiles = () => api.get('/simulation/profiles');
// export const saveSimulationProfile = (data) => api.post('/simulation/profiles', data);
// export const getLogs = (params) => api.get('/simulation/logs', { params });

// // Vehicle endpoints
// export const getVehicles = () => api.get('/vehicles');
// export const addVehicle = (data) => api.post('/vehicles', data);
// export const updateVehicle = (id, data) => api.put(`/vehicles/${id}`, data);
// export const deleteVehicle = (id) => api.delete(`/vehicles/${id}`);
// export const uploadVehicles = (data) => api.post('/vehicles/upload', data);

// // Route endpoints
// export const getRoutes = () => api.get('/routes');
// export const addRoute = (data) => api.post('/routes', data);
// export const updateRoute = (id, data) => api.put(`/routes/${id}`, data);
// export const deleteRoute = (id) => api.delete(`/routes/${id}`);

// export default api;




import axios from 'axios';
import { clearAuth, getAuthToken } from './auth';

const isLocalHost = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);
const API_URL = process.env.REACT_APP_API_URL || (isLocalHost ? 'http://localhost:5000/api' : '/api');

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAuth();
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);

// Authentication endpoints
export const login = (data) => api.post('/auth/login', data);
export const forgotPassword = (data) => api.post('/auth/forgot-password', data);
export const resetPassword = (data) => api.post('/auth/reset-password', data);
export const getMe = () => api.get('/auth/me');
export const logout = () => api.post('/auth/logout');

// Simulation endpoints
export const startSimulation = (data) => api.post('/simulation/start', data);
export const stopSimulation = (profileId = 'love_delhi') => api.post('/simulation/stop', { profileId });
export const getSimulationStatus = (profileId = 'love_delhi') => api.get('/simulation/status', { params: { profileId } });
export const getSimulationProfiles = () => api.get('/simulation/profiles');
export const startBulkInfinity = (data) => api.post('/simulation/start-bulk-infinity', data);
export const getInfinityRuns = (params = {}) => api.get('/simulation/infinity-runs', { params });
export const stopBulkInfinity = (batchId) => api.post('/simulation/stop-bulk-infinity', { batchId });
export const saveSimulationProfile = (data) => api.post('/simulation/profiles', data);
export const deleteSimulationProfile = (profileId) => api.delete(`/simulation/profiles/${encodeURIComponent(profileId)}`);
export const getLogs = (params) => api.get('/simulation/logs', { params });

// Vehicle endpoints
export const getVehicles = () => api.get('/vehicles');
export const addVehicle = (data) => api.post('/vehicles', data);
export const updateVehicle = (id, data) => api.put(`/vehicles/${id}`, data);
export const deleteVehicle = (id) => api.delete(`/vehicles/${id}`);
export const uploadVehicles = (data) => api.post('/vehicles/upload', data);

// Route endpoints
export const getRoutes = (options = {}) => api.get('/routes', { params: options });
export const addRoute = (data) => api.post('/routes', data);
export const updateRoute = (id, data) => api.put(`/routes/${id}`, data);
export const deleteRoute = (id) => api.delete(`/routes/${id}`);

export default api;
